<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="500px"
    persistent
    content-class="ims-standard-dialog"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="title ims-modal-header">
        <span>Change Campaign Settings</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="secondary"
          aria-label="Close"
          title="Close"
          @click.native="$emit('input')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="body-2 ims-modal-body campaign-settings-body" v-if="campaignData">
        <v-text-field
          filled
          label="Campaign"
          v-model="campaignData.name"
          disabled
        ></v-text-field>

        <v-tabs v-model="currentTab" fixed-tabs>
          <v-tab href="#tab-brief">Campaign Brief</v-tab>
          <v-tab href="#tab-report">Report</v-tab>
          <v-tab href="#tab-permissions">Permissions</v-tab>
        </v-tabs>

        <v-tabs-items v-model="currentTab">
          <v-tab-item value="tab-brief">
            <v-card flat>
              <v-card-text>
                <v-switch
                  v-model="submittingData.settings.showBudgetToClient"
                  label="Show Budget To Client"
                ></v-switch>
                <v-switch
                  v-model="submittingData.settings.enableVideoBrief"
                  label="Enable Video Brief"
                ></v-switch>
                <v-switch
                  v-model="submittingData.settings.enableEventBrief"
                  label="Enable Event Brief"
                ></v-switch>
                <v-switch
                  v-model="submittingData.settings.sendWeeklyReport"
                  label="Send Weekly Report"
                ></v-switch>
                <v-switch
                  v-model="submittingData.settings.autoUpdate"
                  label="Auto Update Report"
                ></v-switch>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-report">
            <v-card flat>
              <v-card-text>
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enablePostAnalysis"
                      label="Enable Post Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openPostAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableLinkedInAnalysis"
                      label="Enable LinkedIn Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu
                      :close-on-content-click="false"
                      bottom
                      left
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="secondary"
                          v-bind="attrs"
                          v-on="on"
                          @click="openLinkedInAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableTwitterAnalysis"
                      label="Enable X (Twitter) Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-btn icon color="secondary" @click="openTwitterAnalysisColSettingsModal" class="ml-1">
                      <i class="fas fa-cog fa-lg" title="Settings"></i>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableStoryAnalysis"
                      label="Enable Story Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openStoryAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableReelAnalysis"
                      label="Enable Reel Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                    :close-on-content-click="false" 
                    bottom 
                    left 
                    offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openReelAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableTikTokAnalysis"
                      label="Enable Tiktok Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openTikTokAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableYoutubeAnalysis"
                      label="Enable Youtube Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openYoutubeAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableFbAnalysis"
                      label="Enable Facebook Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openFbAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableXHSAnalysis"
                      label="Enable XHS Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openXHSAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row class="ma-0 pa-0 mb-3 d-flex align-center justify-space-between">
                  <v-col cols="10" class="pa-0">
                    <v-switch
                      v-model="submittingData.settings.enableLemonAnalysis"
                      label="Enable Lemon8 Analysis"
                      hide-details
                      class="ma-0 pa-0 pt-0"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2" class="pa-0 text-right">
                    <v-menu 
                      :close-on-content-click="false" 
                      bottom 
                      left 
                      offset-y
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          icon 
                          color="secondary" 
                          v-bind="attrs" 
                          v-on="on" 
                          @click="openLemonAnalysisColSettingsModal"
                          class="ml-1"
                        >
                          <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-switch
                  v-model="submittingData.settings.enableOverallSection"
                  label="Enable Overall Section"
                ></v-switch>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-permissions">
            <v-card flat>
              <v-card-text>
                <v-row dense>
                  <v-col>
                    <v-btn @click="startAssignCS()" class="ims-btn-third">
                      <v-icon left>mdi-account-switch</v-icon>
                      Manage Permissions
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col sm="12" md="7">
                    <v-btn
                      class="btn__p100"
                      @click="changeCampaignStatus()"
                      color="primary"
                    >
                      <v-icon color="secondary" left>mdi-arrow-left-right</v-icon>
                      <span class="secondary--text">Change Campaign Status</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <v-tooltip
                          right
                          :open-on-hover="false"
                          v-model="reportLinkCopied"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="copyReportLink()"
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon left>mdi-content-copy</v-icon>
                              <span>Copy HTML Report Link</span>
                            </v-btn>
                          </template>
                          <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12">
                        <v-tooltip
                          right
                          :open-on-hover="false"
                          v-model="aiReportLinkCopied"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="copyAIReportLink()"
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon left>mdi-content-copy</v-icon>
                              <span>Copy AI Report Link</span>
                            </v-btn>
                          </template>
                          <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <input type="hidden" id="copy-reportlink" :value="reportLink" />
                    <input type="hidden" id="copy-ai-reportlink" :value="aiReportLink" />
                  </v-col>
                  <v-col cols="12">
                    <v-row class="no-gutters">
                      <v-col md="6" sm="12">
                        <v-btn
                          :class="{ 'btn-change-pass btn__p100': isCampaignPasscode, 'btn-change-pass rounded btn__p100': !isCampaignPasscode, }"
                          @click="startReportPasscode()"
                          color="error"
                        >
                          <v-icon left>mdi-lock</v-icon>
                          Change Passcode
                        </v-btn>
                      </v-col>
                      <v-col md="6" sm="12">
                        <v-tooltip
                          top
                          :open-on-hover="false"
                          v-model="passcodeCopied"
                          v-if="isCampaignPasscode"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="btn-copy-pass btn__p100"
                              @click="copyReportPasscode()"
                              color="success"
                              v-on="on"
                            >
                              <v-icon left>mdi-content-copy</v-icon>
                              <span>Copy Passcode</span>
                            </v-btn>
                          </template>
                          <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                        </v-tooltip>
                        <input
                          type="hidden"
                          id="copy-passcode"
                          :value="campaign.passcode"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <FeedbackAccessPanel v-if="isCopyFeedback" :campaign-id="String(campaignData.id)" />
                <div>
                  <v-divider></v-divider>
                  <v-row dense>
                    <v-col sm="12" md="7">
                      <v-tooltip
                        right
                        :open-on-hover="false"
                        v-model="brandLinkCopied"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="secondary"
                            class="btn__p100"
                            @click="copyBrandSheetLink()"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon left>mdi-content-copy</v-icon>
                            <span>Copy Brand Fact Sheet Link</span>
                          </v-btn>
                        </template>
                        <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                      </v-tooltip>
                    </v-col>
                    <v-col sm="12" md="5">
                      <input
                        type="hidden"
                        id="copy-brand-link"
                        :value="brandSheetLink"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions class="ims-modal-actions">
        <v-btn id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
    <assign-cs-to-campaign-modal
      :campaign="campaignDataForCsAssign"
      @updated="reload"
      v-model="assignCsToCampaignDialog"
    />
    <report-passcode-modal
      :campaign="campaignData"
      @updated="reload"
      v-model="reportPasscodeDialog"
    />
    <change-status-modal
      :campaign="campaignDataForStatusChange"
      @updated="reload"
      v-model="changeCampaignStatusDialog"
    />
    <table-cols-show-hide-modal
      v-model="postAnalysisColSettingsDialog"
      title="Post Analysis Columns"
      :items="postAnalysisTableColsItems"
      @updated="updatePostAnalysisStatus"
      :isSort="true"
    />
    <table-cols-show-hide-modal
      v-model="storyAnalysisColSettingsDialog"
      title="Story Analysis Columns"
      :items="storyAnalysisTableColsItems"
      @updated="updateStoryAnalysisStatus"
      :isSort="true"
    />
    <table-cols-show-hide-modal
      v-model="reelAnalysisColSettingsDialog"
      title="Reel Analysis Columns"
      :items="reelAnalysisTableColsItems"
      @updated="updateReelAnalysisStatus"
      :isSort="true"
    />
      <table-cols-show-hide-modal
      v-model="tiktokAnalysisColSettingsDialog"
      title="Tiktok Analysis Columns"
      :items="tiktokAnalysisTableColsItems"
      @updated="updateTikTokAnalysisStatus"
      :isSort="true"
    />
    <table-cols-show-hide-modal
      v-model="youtubeAnalysisColSettingsDialog"
      title="Youtube Analysis Columns"
      :items="youtubeAnalysisTableColsItems"
      @updated="updateYoutubeAnalysisStatus"
    />
    <table-cols-show-hide-modal
      v-model="fbAnalysisColSettingsDialog"
      title="Facebook Analysis Columns"
      :items="fbAnalysisTableColsItems"
      @updated="updateFbAnalysisStatus"
    />
    <table-cols-show-hide-modal
      v-model="linkedInAnalysisColSettingsDialog"
      title="LinkedIn Analysis Columns"
      :items="linkedInAnalysisTableColsItems"
      @updated="updateLinkedInAnalysisStatus"
    />
    <table-cols-show-hide-modal
      v-model="twitterAnalysisColSettingsDialog"
      title="X (Twitter) Analysis Columns"
      :items="twitterAnalysisTableColsItems"
      @updated="updateTwitterAnalysisStatus"
    />
      <table-cols-show-hide-modal
      v-model="xhsAnalysisColSettingsDialog"
      title="XHS Analysis Columns"
      :items="xhsAnalysisTableColsItems"
      @updated="updateXHSAnalysisStatus"
    />
      <table-cols-show-hide-modal
      v-model="lemonAnalysisColSettingsDialog"
      title="Lemon8 Analysis Columns"
      :items="lemonAnalysisTableColsItems"
      @updated="updateLemonAnalysisStatus"
    />
  </v-dialog>
</template>
<script>
/* eslint-disable */
import config from '@/config';
import userAPIs from '../User/userAPIs';
import campaignAPIs from './campaignAPIs';
import FeedbackAccessPanel from './FeedbackAccessPanel.vue';
import AssignCsToCampaignModal from './AssignCStoCampaignModal';
import ChangeStatusModal from './ChangeCampaignStatusModal';
import ReportPasscodeModal from './ReportPasscodeModal';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import utils from '../../../utils';

export default {
  name: 'CampaignSettings',
  components: {
    FeedbackAccessPanel,
    AssignCsToCampaignModal,
    ChangeStatusModal,
    ReportPasscodeModal,
    TableColsShowHideModal
  },
  props: {
    value: Boolean,
    campaign: Object
  },
  data() {
    return {
      currentTab: 'tab-brief', // Default tab
      assignCsToCampaignDialog: false,
      postAnalysisColSettingsDialog: false,
      postAnalysisTableColsItems: [],
      storyAnalysisColSettingsDialog: false, 
      storyAnalysisTableColsItems: [], 
      tiktokAnalysisColSettingsDialog: false,
      tiktokAnalysisTableColsItems: [],
      reelAnalysisColSettingsDialog: false,
      reelAnalysisTableColsItems: [],
      youtubeAnalysisColSettingsDialog: false,
      youtubeAnalysisTableColsItems: [],
      fbAnalysisColSettingsDialog: false,
      fbAnalysisTableColsItems: [],
      linkedInAnalysisColSettingsDialog: false,
      linkedInAnalysisTableColsItems: [],
      twitterAnalysisColSettingsDialog: false,
      twitterAnalysisTableColsItems: [],
      xhsAnalysisColSettingsDialog: false,
      xhsAnalysisTableColsItems: [],
      lemonAnalysisColSettingsDialog: false,
      lemonAnalysisTableColsItems: [], 
      reportPasscodeDialog: false,
      changeCampaignStatusDialog: false,
      campaignData: null,
      campaignDataForStatusChange: null,
      campaignDataForCsAssign: null,
      submittingData: {
        settings: {
          sendWeeklyReport: false,
          autoUpdate: false,
          showBudgetToClient: false,
          enableVideoBrief: false,
          enableEventBrief: false,
          enablePostAnalysis: false,
          enableStoryAnalysis: false,
          enableReelAnalysis: false,
          enableTikTokAnalysis: false,
          enableYoutubeAnalysis: false,
          enableFbAnalysis: false,
          enableLinkedInAnalysis: false,
          enableTwitterAnalysis: false,
          enableXHSAnalysis: false,
          enableLemonAnalysis: false,
          enableOverallSection: false,
          // NOTE: These properties are left empty/as defaults for the submission object. 
          // Column status is handled outside of 'settings' in the payload.
          postAnalysisStatus: {},
          storyAnalysisStatus: {},
          reelAnalysisStatus: {},
          tiktokAnalysisStatus: {},
          youtubeAnalysisStatus: {},
          fbAnalysisStatus: {},
          linkedInAnalysisStatus: {},
          twitterAnalysisStatus: {},
          xhsAnalysisStatus: {},
          lemonAnalysisStatus: {}, 
        }
      },
      // --- DEFAULT COLUMN STATUS (FLAT OBJECTS - ONLY FOR FALLBACK VISIBILITY) ---
      defaultPostsAnalysisStatus: {
        showEngagement: true,
        showEngagementView: false,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false,
        showBookmarks: false,
        showShares: false,
        showInteractions: false,
        showViews: false,
        likes: false,
        comments: false,
        shares: false,
        showReach: false,
        showImpressions: false,
        showPlays: false,
        showWatches: false,
        liveDate: false,
        url: false
      },
      defaultStoryAnalysisStatus: {
        showShares: true,
        showReplies: true,
        showLinkClicks: true,
        showStickerTaps: true,
        showInteractions: false,
        showReach: false,
        showImpressions: false,
        showAvgViews: false,
        showAvgReelsPlays: false,
        liveDate: false
      },
      defaultReelAnalysisStatus: {
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false,
        showBookmarks: true,
        showShares: false,
        showInteractions: false,
        showViews: false,
        likes: true,
        comments: false,
        shares: true,
        showReach: false,
        showImpressions: false,
        showPlays: false,
        showWatches: false,
        liveDate: false,
        url: false
      },
      defaultTikTokAnalysisStatus: {
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateTotalViewers: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showViews: false,
        likes: false,
        comments: false,
        shares: false,
        showBookmarks: true,
        showInteractions: false,
        showReach: false,
        showImpressions: false,
        showPlays: false,
        showWatches: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        avgSaves: false,
        avgShares: false,
        showWatchedFullVideo: false,
        liveDate: false,
        url: false
      },
      defaultYoutubeAnalysisStatus: {
        showEngagement: true,
        showEngagementView: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showViews: false,
        likes: false,
        comments: false,
        showInteractions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        liveDate: false,
        url: false
      },
      defaultFbAnalysisStatus: {
        showLikes: true,
        showComments: true,
        showViews: true,
        showShares: true,
        showBookmarks: false,
        showInteractions: false,
        liveDate: false,
        url: false,
        showReach: false,
      },
      defaultLinkedInAnalysisStatus: {
        liveDate: false,
        url: false,
        showImpressions: true,
        showReach: true,
        showVideoViews: true,
        showProfileViewers: true,
        showLikes: true,
        showComments: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false,
      },
      defaultTwitterAnalysisStatus: {
        liveDate: false,
        url: false,
        showImpressions: true,
        showComments: true,
        showLikes: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false,
      },
      defaultXHSAnalysisStatus: {
        showViews: true,
        showWatches: true,
        showLikes: true,
        showComments: true,
        showBookmarks: false,
        showShares: true,
        showInteractions: false,
        liveDate: false,
        url: false,
        showReach: false,
      },
      defaultLemonAnalysisStatus: {
        showViews: true,
        showWatches: true,
        showLikes: true,
        showComments: true,
        showBookmarks: false,
        showShares: true,
        showInteractions: false,
        liveDate: false, 
        url: false, 
        showReach: false, 
      },
      // --- COLUMN DEFINITIONS (FOR LABELS AND ORDER TEMPLATE) ---
      postAnalysisColumns: [
        {
          name: 'liveDate',
          label: 'Live Date'
        },
        {
          name: 'url',
          label: 'Post URL'
        },
        {
          name: 'outreach',
          label: 'Audience Size'
        },
        {
          name: 'showReach',
          label: 'Accounts Reached'
        },
        {
          name: 'showImpressions',
          label: 'Impressions'
        },
        {
          name: 'likes',
          label: 'Likes'
        },
        {
          name: 'showShares',
          label: 'Shares'
        },
        {
          name: 'comments',
          label: 'Comments'
        },
        {
          name: 'showBookmarks',
          label: 'Bookmarks'
        },
        {
          name: 'showInteractions',
          label: 'Interactions'
        },
        // {
        // 	name: 'showViews',
        // 	label: 'Views'
        // },
        {
          name: 'showEngagement',
          label: 'Engagement Rate by Audience Size'
        },
        // {
        // 	name: 'showEngagementView',
        // 	label: 'Play Rate (by Audience Size)'
        // },
        {
          name: 'showEngRateReach',
          label: 'Engagement Rate by Reach'
        },
        {
          name: 'showAvgEngagement',
          label: 'Avg. Engagement Rate'
        },
        {
          name: 'showMediaEngagement',
          label: 'Median Engagement Rate'
        },
        {
          name: 'showAvgLikes',
          label: 'Average Likes'
        },
        {
          name: 'showAvgComments',
          label: 'Average Comments'
        },
        {
          name: 'showAvgViews',
          label: 'Average Views'
        }
      ],
      storyAnalysisColumns: [
        { name: 'showShares', label: 'Shares' },
        { name: 'showReplies', label: 'Replies' },
        { name: 'showLinkClicks', label: 'Links Click' },
        { name: 'showStickerTaps', label: 'Sticker Taps' },
        { name: 'showInteractions', label: 'Interactions' },
        { name: 'showReach', label: 'Reach' },
        { name: 'showImpressions', label: 'Impressions' },
        { name: 'showAvgViews', label: 'Average Views' },
        { name: 'showAvgReelsPlays', label: 'Average Reels Plays' },
        { name: 'liveDate', label: 'Live Date' }
      ],
      reelAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'url', label: 'Post URL' },
        { name: 'outreach', label: 'Audience Size' },
        { name: 'showReach', label: 'Accounts Reached' },
        { name: 'showImpressions', label: 'Impressions' },
        { name: 'likes', label: 'Likes' },
        { name: 'comments', label: 'Comments' },
        { name: 'showBookmarks', label: 'Bookmarks' },
        { name: 'showShares', label: 'Shares' },
        { name: 'showInteractions', label: 'Interactions' },
        { name: 'showViews', label: 'Plays' },
        { name: 'showPlays', label: 'Watch Time' },
        { name: 'showWatches', label: 'Average Watch Time' },
        { name: 'showAvgReelsPlays', label: 'Avg Reels Plays' },
        { name: 'showEngagement', label: 'Engagement Rate by Audience Size' },
        { name: 'showEngagementView', label: 'Play Rate (by Audience Size)' },
        { name: 'showInteractionPlays', label: 'Engagement Rate by Plays' },
        { name: 'showEngRateReach', label: 'Engagement Rate by Reach' },
        { name: 'showAvgEngagement', label: 'Avg. Engagement Rate' },
        { name: 'showMediaEngagement', label: 'Median Engagement Rate' },
        { name: 'showAvgLikes', label: 'Average Likes' },
        { name: 'showAvgComments', label: 'Average Comments' },
        { name: 'showAvgViews', label: 'Average Views' }
      ],
      tiktokAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'url', label: 'Post URL' },
        { name: 'outreach', label: 'Audience Size' },
        { name: 'showReach', label: 'Accounts Reached' },
        { name: 'showImpressions', label: 'Impressions' },
        { name: 'likes', label: 'Likes' },
        { name: 'comments', label: 'Comments' },
        { name: 'shares', label: 'Shares' },
        { name: 'showBookmarks', label: 'Bookmarks' },
        { name: 'showInteractions', label: 'Interactions' },
        { name: 'showViews', label: 'Plays' },
        { name: 'showPlays', label: 'Total Play Time' },
        { name: 'showWatches', label: 'Average Watch Time' },
        { name: 'showWatchedFullVideo', label: 'Watched Full Video' },
        { name: 'showEngagement', label: 'Engagement Rate by Audience Size' },
        { name: 'showEngagementView', label: 'Play Rate (by Audience Size)' },
        { name: 'showInteractionPlays', label: 'Engagement Rate by Plays' },
        { name: 'showEngRateTotalViewers', label: 'Engagement Rate by Accounts Reached' },
        { name: 'showAvgEngagement', label: 'Avg. Engagement Rate' },
        { name: 'showMediaEngagement', label: 'Median Engagement Rate' },
        { name: 'avgViews', label: 'Average Views' },
        { name: 'avgLikes', label: 'Average Likes' },
        { name: 'avgComments', label: 'Average Comments' },
        { name: 'avgSaves', label: 'Average Saves' },
        { name: 'avgShares', label: 'Average Shares' },
      ],
      youtubeAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'url', label: 'Post URL' },
        { name: 'showEngagement', label: 'Engagement Rate by Interactions' },
        { name: 'showEngagementView', label: 'Engagement Rate by Views' },
        { name: 'showAvgEngagement', label: 'Average Engagement Rate' },
        { name: 'showMediaEngagement', label: 'Median Engagement Rate' },
        { name: 'showViews', label: 'Total Views' },
        { name: 'likes', label: 'Likes' },
        { name: 'comments', label: 'Comments' },
        { name: 'showInteractions', label: 'Interactions' },
        { name: 'avgViews', label: 'Average Views' },
        { name: 'avgLikes', label: 'Average Likes' },
        { name: 'avgComments', label: 'Average Comments' },
      ],
      fbAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'url', label: 'Post URL' },
        { name: 'showShares', label: 'Shares' },
        { name: 'showLikes', label: 'Likes' },
        { name: 'showComments', label: 'Comments' },
        { name: 'showViews', label: 'Views' },
        { name: 'showReach', label: 'Reach' },
        { name: 'showBookmarks', label: 'Bookmarks' },
        { name: 'showInteractions', label: 'Interactions' },
      ],
      linkedInAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'url', label: 'Post URL' },
        { name: 'showImpressions', label: 'Impressions' },
        { name: 'showReach', label: 'Members reached' },
        { name: 'showVideoViews', label: 'Video views' },
        { name: 'showProfileViewers', label: 'Profile viewers from this post' },
        { name: 'showLikes', label: 'Reactions' },
        { name: 'showComments', label: 'Comments' },
        { name: 'showShares', label: 'Reposts' },
        { name: 'showBookmarks', label: 'Saves' },
      ],
      twitterAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'url', label: 'Post URL' },
        { name: 'showImpressions', label: 'Impressions' },
        { name: 'showComments', label: 'Replies' },
        { name: 'showLikes', label: 'Likes' },
        { name: 'showShares', label: 'Reposts' },
        { name: 'showBookmarks', label: 'Bookmarks' },
      ],
      xhsAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'showReach', label: 'Reach' },
        { name: 'showViews', label: 'Views' },
        { name: 'showWatches', label: 'Average Watch Time' },
        { name: 'showLikes', label: 'Likes' },
        { name: 'showBookmarks', label: 'Saves' },
        { name: 'showComments', label: 'Comments' },
        { name: 'showShares', label: 'Shares' },
        { name: 'showInteractions', label: 'Interactions' }
      ],
      lemonAnalysisColumns: [
        { name: 'liveDate', label: 'Live Date' },
        { name: 'showReach', label: 'Reach' },
        { name: 'showViews', label: 'Views' },
        { name: 'showWatches', label: 'Average Watch Time' },
        { name: 'showLikes', label: 'Likes' },
        { name: 'showBookmarks', label: 'Saves' },
        { name: 'showComments', label: 'Comments' },
        { name: 'showShares', label: 'Shares' },
        { name: 'showInteractions', label: 'Interactions' }
      ],

      show1: false,
      passcodeCopied: false,
      reportLink: '',
      aiReportLink: '', // New property for AI Report Link
      aiReportLinkCopied: false, // New property for AI Report Link tooltip
      feedbackLink: '',
      isCopyFeedback: false,
      linkCopied: false,
      reportLinkCopied: false,
      brandLinkCopied: false,
      brandSheetLink: ''
    }
  },
  methods: {
    // --- GENERIC HELPER FOR COLUMN INITIALIZATION (GETS ORDER FROM SAVED OBJECT KEYS) ---
    getOrderedColumns(columnDefs, currentStatus, defaultStatus) {
      let currentOrder = [];
      let currentKeys = new Set();
      
      // 1. Get ordered keys from currentStatus (Relies on JS engine insertion order)
      if (currentStatus && Object.keys(currentStatus).length > 0) {
        Object.keys(currentStatus).forEach(key => {
          const colDef = columnDefs.find(c => c.name === key);
          if (colDef) {
            currentOrder.push({
              title: colDef.label,
              key: key,
              value: currentStatus[key]
            });
            currentKeys.add(key);
          }
        });
      }

      // 2. Add remaining default columns (that haven't been saved yet) to the end
      columnDefs.forEach(colDef => {
        if (!currentKeys.has(colDef.name)) {
          currentOrder.push({
            title: colDef.label,
            key: colDef.name,
            // Use default status for new columns, fallback to false
            value: defaultStatus.hasOwnProperty(colDef.name) ? defaultStatus[colDef.name] : false
          });
          currentKeys.add(colDef.name);
        }
      });
      return currentOrder;
    },

    // --- GENERIC HELPER FOR UPDATING COLUMN STATUS (SAVES BACK TO FLAT OBJECT AT ROOT LEVEL) ---
    async updateColumnsStatus(items, campaignDataProp, dialogProp) {
        let newStatusObject = {};
        
        // 1. Create the new flat object. Order is implicitly captured by key insertion order.
        items.forEach((item) => {
            newStatusObject[item.key] = item.value;
        });
        
        // 2. Construct the API payload based on your example: { id, statusObject }
        let data = [
            Object.assign({}, {
                id: this.campaignData.id,
                [campaignDataProp]: newStatusObject // Directly map status object to campaign property name
            })
        ];
        
        try {
            // NOTE: Using campaign/updateCampaignByIds expects the endpoint to handle 
            // updating properties directly from the root of the data object.
            await this.$store.dispatch('campaign/updateCampaignByIds', data);
            
            // 3. Update the local campaignData property directly
            this.campaignData[campaignDataProp] = newStatusObject;
            this[dialogProp] = false;

            this.$swal.fire({
                type: 'success',
                title: 'Updated!',
                text: `Column settings saved successfully.`,
                showCancelButton: false,
                width: 300
            });
        } catch (error) {
            console.error('Error updating campaign settings:', error);
            this.$swal.fire({
                type: 'error',
                title: 'Error',
                text: 'Failed to save column settings. Please try again.',
                showCancelButton: false,
                width: 300
            });
        }
    },

    // --- SPECIFIC INITIALIZERS AND OPENERS (USING campaignData.*Status) ---
    initializePostAnalysisTableCols() {
        this.postAnalysisTableColsItems = this.getOrderedColumns(
          this.postAnalysisColumns,
          this.campaignData.postAnalysisStatus,
          this.defaultPostsAnalysisStatus
        );
    },
    openPostAnalysisColSettingsModal() {
        this.initializePostAnalysisTableCols();
        this.postAnalysisColSettingsDialog = true;
    },
    async updatePostAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'postAnalysisStatus', 'postAnalysisColSettingsDialog');
    },
    
    initializeStoryAnalysisTableCols() {
        this.storyAnalysisTableColsItems = this.getOrderedColumns(
          this.storyAnalysisColumns,
          this.campaignData.storyAnalysisStatus,
          this.defaultStoryAnalysisStatus
        );
    },
    openStoryAnalysisColSettingsModal() {
        this.initializeStoryAnalysisTableCols();
        this.storyAnalysisColSettingsDialog = true;
    },
    async updateStoryAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'storyAnalysisStatus', 'storyAnalysisColSettingsDialog');
    },

    initializeReelAnalysisTableCols() {
        this.reelAnalysisTableColsItems = this.getOrderedColumns(
          this.reelAnalysisColumns,
          this.campaignData.reelAnalysisStatus,
          this.defaultReelAnalysisStatus
        );
    },
    openReelAnalysisColSettingsModal() {
        this.initializeReelAnalysisTableCols();
        this.reelAnalysisColSettingsDialog = true;
    },
    async updateReelAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'reelAnalysisStatus', 'reelAnalysisColSettingsDialog');
    },

    initializeTikTokAnalysisTableCols() {
        this.tiktokAnalysisTableColsItems = this.getOrderedColumns(
          this.tiktokAnalysisColumns,
          this.campaignData.tikTokAnalysisStatus,
          this.defaultTikTokAnalysisStatus
        );
    },
    openTikTokAnalysisColSettingsModal() {
        this.initializeTikTokAnalysisTableCols();
        this.tiktokAnalysisColSettingsDialog = true;
    },
    async updateTikTokAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'tikTokAnalysisStatus', 'tiktokAnalysisColSettingsDialog');
    },

    initializeYoutubeAnalysisTableCols() {
        this.youtubeAnalysisTableColsItems = this.getOrderedColumns(
          this.youtubeAnalysisColumns,
          this.campaignData.youtubeAnalysisStatus,
          this.defaultYoutubeAnalysisStatus
        );
    },
    openYoutubeAnalysisColSettingsModal() {
        this.initializeYoutubeAnalysisTableCols();
        this.youtubeAnalysisColSettingsDialog = true;
    },
    async updateYoutubeAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'youtubeAnalysisStatus', 'youtubeAnalysisColSettingsDialog');
    },
    
    initializeFbAnalysisTableCols() {
        this.fbAnalysisTableColsItems = this.getOrderedColumns(
          this.fbAnalysisColumns,
          this.campaignData.fbAnalysisStatus,
          this.defaultFbAnalysisStatus
        );
    },
    openFbAnalysisColSettingsModal() {
        this.initializeFbAnalysisTableCols();
        this.fbAnalysisColSettingsDialog = true;
    },
    async updateFbAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'fbAnalysisStatus', 'fbAnalysisColSettingsDialog');
    },

    initializeLinkedInAnalysisTableCols() {
        this.linkedInAnalysisTableColsItems = this.getOrderedColumns(
          this.linkedInAnalysisColumns,
          this.campaignData.linkedInAnalysisStatus,
          this.defaultLinkedInAnalysisStatus
        );
    },
    openLinkedInAnalysisColSettingsModal() {
        this.initializeLinkedInAnalysisTableCols();
        this.linkedInAnalysisColSettingsDialog = true;
    },
    async updateLinkedInAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'linkedInAnalysisStatus', 'linkedInAnalysisColSettingsDialog');
    },

    initializeTwitterAnalysisTableCols() {
        this.twitterAnalysisTableColsItems = this.getOrderedColumns(
          this.twitterAnalysisColumns,
          this.campaignData.twitterAnalysisStatus,
          this.defaultTwitterAnalysisStatus
        );
    },
    openTwitterAnalysisColSettingsModal() {
        this.initializeTwitterAnalysisTableCols();
        this.twitterAnalysisColSettingsDialog = true;
    },
    async updateTwitterAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'twitterAnalysisStatus', 'twitterAnalysisColSettingsDialog');
    },

    initializeXHSAnalysisTableCols() {
        this.xhsAnalysisTableColsItems = this.getOrderedColumns(
          this.xhsAnalysisColumns,
          this.campaignData.xhsAnalysisStatus,
          this.defaultXHSAnalysisStatus
        );
    },
    openXHSAnalysisColSettingsModal() {
        this.initializeXHSAnalysisTableCols();
        this.xhsAnalysisColSettingsDialog = true;
    },
    async updateXHSAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'xhsAnalysisStatus', 'xhsAnalysisColSettingsDialog');
    },

    initializeLemonAnalysisTableCols() {
        this.lemonAnalysisTableColsItems = this.getOrderedColumns(
          this.lemonAnalysisColumns,
          this.campaignData.lemonAnalysisStatus,
          this.defaultLemonAnalysisStatus
        );
    },
    openLemonAnalysisColSettingsModal() {
        this.initializeLemonAnalysisTableCols();
        this.lemonAnalysisColSettingsDialog = true;
    },
    async updateLemonAnalysisStatus(items) {
        await this.updateColumnsStatus(items, 'lemonAnalysisStatus', 'lemonAnalysisColSettingsDialog');
    },

    // --- REST OF ORIGINAL METHODS + NEW AI Report Link Method ---
    changeCampaignStatus() {
      this.campaignDataForStatusChange = this.campaignData;
      this.changeCampaignStatusDialog = !this.changeCampaignStatusDialog;
    },
    startAssignCS() {
      this.campaignDataForCsAssign = this.campaignData;
      this.assignCsToCampaignDialog = !this.assignCsToCampaignDialog;
    },
    startReportPasscode() {
      this.reportPasscodeDialog = !this.reportPasscodeDialog;
    },
    close() {
      this.$emit('input');
    },
    save() {
      // NOTE: This save function handles only the switch-based properties in submittingData.settings
      campaignAPIs
        .updateCampaignSetting(this.campaignData.id, this.submittingData)
        .then((response) => {
          console.log('update success');
          this.reload();
          this.close();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reload() {
      this.close();
      this.$emit('saved', true);
    },
    copyReportLink() {
      const protocol = window.location.protocol;
      const host = window.location.host;
      this.reportLink = `${protocol}//${host}/reports/campaign/summary?id=${this.campaignData.id}`;
      let vm = this;
      setTimeout(function () {
        vm.reportLinkCopied = utils.func.copyToClipboard('#copy-reportlink');
      }, 100);
      setTimeout(function () {
        vm.reportLinkCopied = false;
      }, 1000);
    },
    // Copy AI Report Link — the new Kobe-branded HTML report
    // (/reports/campaign/html). Passcode embedded so the client lands straight
    // on the report; retired the old /html-report route.
    copyAIReportLink() {
      const protocol = window.location.protocol;
      const host = window.location.host;
      this.aiReportLink = `${protocol}//${host}/reports/campaign/html?id=${this.campaignData.id}&passcode=${encodeURIComponent(this.campaignData.passcode || '')}`;
      let vm = this;
      setTimeout(function () {
        vm.aiReportLinkCopied = utils.func.copyToClipboard('#copy-ai-reportlink');
      }, 100);
      setTimeout(function () {
        vm.aiReportLinkCopied = false;
      }, 1000);
    },
    copyBrandSheetLink() {
      const protocol = window.location.protocol;
      const host = window.location.host;
      this.brandSheetLink = `${protocol}//${host}${config.BRAND_SHEET_FORM_URL}/${this.campaignData.id}`;
      let vm = this;
      setTimeout(function () {
        vm.brandLinkCopied = utils.func.copyToClipboard('#copy-brand-link');
      }, 100);
      setTimeout(function () {
        vm.brandLinkCopied = false;
      }, 1000);
    },
    copyFeedbackShow() {
      const buttonPermission = config['userPermissions']['campaign']['clientFeedback'];
      if (Array.isArray(buttonPermission) && this.selectedAMList.length) {
        return buttonPermission.includes(this.currentUserRole);
      }
      return false;
    },
    copyReportPasscode() {
      let vm = this;
      setTimeout(function () {
        vm.passcodeCopied = utils.func.copyToClipboard('#copy-passcode');
      }, 100);
      setTimeout(function () {
        vm.passcodeCopied = false;
      }, 1000);
    },
    fetchAMlist(assignedTo) {
      userAPIs
        .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        .then((resp) => {
          this.accountManagers = resp.users;
          if (assignedTo) {
            resp.users.map((item) => {
              assignedTo.map((id) => {
                if (item.id === id) {
                  this.selectedAMList.push(id);
                }
              });
            });

            this.isCopyFeedback = this.copyFeedbackShow();
          }
        })
        .catch((err) => console.error(err));
    }
  },
  computed: {
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    isCampaignPasscode: function () {
      if (this.campaignData.passcode) {
        return true;
      }
      return false;
    }
  },
  watch: {
    campaign(newCampaign) {
      if (newCampaign !== null) {
        const settings = newCampaign.settings || {};
        this.campaignData = newCampaign;
        
        // --- General Settings Initialization (from settings) ---
        this.submittingData.settings.showBudgetToClient = settings.showBudgetToClient || false;
        this.submittingData.settings.enableVideoBrief = settings.enableVideoBrief || false;
        this.submittingData.settings.enableEventBrief = settings.enableEventBrief || false;
        this.submittingData.settings.enablePostAnalysis = settings.enablePostAnalysis || false;
        this.submittingData.settings.enableStoryAnalysis = settings.enableStoryAnalysis || false;
        this.submittingData.settings.enableReelAnalysis = settings.enableReelAnalysis || false;
        this.submittingData.settings.enableTikTokAnalysis = settings.enableTikTokAnalysis || false;
        this.submittingData.settings.enableYoutubeAnalysis = settings.enableYoutubeAnalysis || false;
        this.submittingData.settings.enableFbAnalysis = settings.enableFbAnalysis || false;
        this.submittingData.settings.enableLinkedInAnalysis = settings.enableLinkedInAnalysis || false;
        this.submittingData.settings.enableTwitterAnalysis = settings.enableTwitterAnalysis || false;
        this.submittingData.settings.enableXHSAnalysis = settings.enableXHSAnalysis || false;
        this.submittingData.settings.enableLemonAnalysis = settings.enableLemonAnalysis || false;
        this.submittingData.settings.enableOverallSection = settings.enableOverallSection || false;
        this.submittingData.settings.sendWeeklyReport = settings.sendWeeklyReport || false;
        this.submittingData.settings.autoUpdate = settings.autoUpdate || false;
        
        // --- Column Status Initialization (Loading/Setting status from campaignData.*Status) ---
        // Load existing status from campaignData or set empty object fallback
        this.campaignData.postAnalysisStatus = this.campaignData.postAnalysisStatus || {};
        this.initializePostAnalysisTableCols();

        this.campaignData.storyAnalysisStatus = this.campaignData.storyAnalysisStatus || {};
        this.initializeStoryAnalysisTableCols();
        
        this.campaignData.reelAnalysisStatus = this.campaignData.reelAnalysisStatus || {};
        this.initializeReelAnalysisTableCols();
        
        this.campaignData.tikTokAnalysisStatus = this.campaignData.tikTokAnalysisStatus || {};
        this.initializeTikTokAnalysisTableCols();

        this.campaignData.youtubeAnalysisStatus = this.campaignData.youtubeAnalysisStatus || {};
        this.initializeYoutubeAnalysisTableCols();
        
        this.campaignData.fbAnalysisStatus = this.campaignData.fbAnalysisStatus || {};
        this.initializeFbAnalysisTableCols();

        this.campaignData.linkedInAnalysisStatus = this.campaignData.linkedInAnalysisStatus || {};
        this.initializeLinkedInAnalysisTableCols();

        this.campaignData.twitterAnalysisStatus = this.campaignData.twitterAnalysisStatus || {};
        this.initializeTwitterAnalysisTableCols();

        this.campaignData.xhsAnalysisStatus = this.campaignData.xhsAnalysisStatus || {};
        this.initializeXHSAnalysisTableCols();

        this.campaignData.lemonAnalysisStatus = this.campaignData.lemonAnalysisStatus || {};
        this.initializeLemonAnalysisTableCols();
        
        this.selectedAMList = [];
        this.fetchAMlist(this.campaignData.assignedTo);
      }
    }
  }
};
</script>

<style scoped>
  .campaign-settings-body {
    padding-top: 16px !important;
  }

  .btn-change-pass {
  border-radius: 5px 0 0 5px !important;
}

.btn-copy-pass {
  border-radius: 0 5px 5px 0 !important;
}
</style>



// WEBPACK FOOTER //
// CampaignSettingsModal.vue?17d75232